import { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import PermissionsCheck from "./PermissionsCheck";

import {
  FilterBar,
  Container,
  DataGrid,
  Paginate,
  Dialog,
  InputText,
} from "src/components";
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Cancel as CancelIcon,
  BorderColor as BorderColorIcon,
  Eject as EjectIcon,
} from "@material-ui/icons";

import * as types from "src/store/types/usuarios";
import {
  atualizarSituacao,
  carregarUsuarios,
} from "src/store/actions/usuarios";
import { Grid } from "@material-ui/core";
import ModalUsuario from "./ModalUsuario";

function Usuarios() {
  const [modal, setModal] = useState("");
  const [usuario, setUsuario] = useState({});

  const {
    usuarios,
    usuarios_page,
    usuarios_perpage,
    usuarios_total,
    usuarios_loading,
    usuarios_filtro,
  } = useSelector((state) => state.usuarios);

  const dispatch = useDispatch();

  const setFiltro = (value) =>
    dispatch({ type: types.USUARIOS_SET_FILTRO, payload: { ...value } });

  useEffect(() => {
    dispatch(
      carregarUsuarios({ page: usuarios_page, per_page: usuarios_perpage })
    );
  }, [usuarios_page, usuarios_perpage]);

  const handleOpenModalPermissoes = (event, data) => {
    setUsuario(data);
    setModal("permissoes");
  };

  const handleCloseModal = () => setModal("");

  const handleChangePage = (event, newPage) => {
    dispatch([
      { type: types.USUARIOS_LOADING, payload: true },
      { type: types.USUARIOS_SET_PAGE, payload: newPage + 1 },
    ]);
  };

  const handleChangeRowsPerPage = (event) => {
    dispatch([
      { type: types.USUARIOS_LOADING, payload: true },
      {
        type: types.USUARIOS_SET_PERPAGE,
        payload: parseInt(event.target.value),
      },
    ]);
  };

  const handleAtualizarSituacao = async (situacao) => {
    await atualizarSituacao(usuario.id, situacao);
    handleCloseModal();
  };

  const pesquisar = () => dispatch(carregarUsuarios());

  const limparFiltros = () => {
    dispatch([
      {
        type: types.USUARIOS_SET_FILTRO,
        payload: {
          situacao: "A",
          nome: "",
        },
      },
      carregarUsuarios(),
    ]);
  };

  return (
    <Container
      title="Listagem de usuários"
      buttonsRight={[
        {
          title: "Novo",
          icon: <AddIcon />,
          onClick: () => {
            setModal("usuario");
          },
        },
      ]}
    >
      <Dialog
        visible={modal === "desativar"}
        title="Desativar usuário"
        contenttext={`Deseja realmente desativar o usuário ${usuario.nome}`}
        buttons={[
          {
            title: "Desativar",
            icon: <DeleteIcon />,
            onClick: () => handleAtualizarSituacao("I"),
            danger: true,
          },
          {
            title: "Cancelar",
            icon: <CancelIcon />,
            onClick: handleCloseModal,
          },
        ]}
      />

      <Dialog
        visible={modal === "ativar"}
        title="Desativar usuário"
        contenttext={`Deseja realmente ativar o usuário ${usuario.nome}`}
        buttons={[
          {
            title: "Ativar",
            icon: <EjectIcon />,
            onClick: () => handleAtualizarSituacao("A"),
            danger: true,
          },
          {
            title: "Cancelar",
            icon: <CancelIcon />,
            onClick: handleCloseModal,
          },
        ]}
      />
      <ModalUsuario open={modal === "usuario"} close={handleCloseModal} />

      <PermissionsCheck
        open={modal === "permissoes"}
        close={handleCloseModal}
        usuario={usuario}
      />

      <FilterBar
        searchFilter={pesquisar}
        clearFilter={limparFiltros}
        title="Clique aqui para visualizar as opções de filtro."
      >
        <Grid container spacing={2}>
          <Grid item sm={6}>
            <InputText
              label="Nome"
              value={usuarios_filtro.nome}
              onChange={(e) => setFiltro({ nome: e.target.value })}
            />
          </Grid>
          <Grid item sm={2}>
            <InputText
              select
              label="Situação"
              value={usuarios_filtro.situacao}
              onChange={(event) => setFiltro({ situacao: event.target.value })}
              SelectProps={{ native: true }}
              InputLabelProps={{ shrink: true }}
            >
              <option value="A"> Ativo </option>
              <option value="I"> Inativo </option>
            </InputText>
          </Grid>
        </Grid>
      </FilterBar>
      <PerfectScrollbar>
        <DataGrid
          isLoading={usuarios_loading}
          columns={[
            {
              title: "ID",
              field: "id",
              width: 30,
              headerStyle: { paddingLeft: 10 },
              cellStyle: { paddingLeft: 10 },
            },
            {
              title: "Nome",
              field: "nome",
              width: "auto",
              headerStyle: { paddingLeft: 10 },
              cellStyle: {
                paddingLeft: 10,
              },
            },
            {
              title: "Email",
              field: "email",
              width: 150,
              headerStyle: {},
              cellStyle: {},
            },
          ]}
          data={usuarios}
          options={{}}
          actions={[
            {
              icon: () => <BorderColorIcon color="primary" />,
              tooltip: "Permissões",
              onClick: handleOpenModalPermissoes,
            },
            (rowData) => ({
              hidden: rowData.situacao === "I" ? true : false,
              icon: () => <DeleteIcon color="error" />,
              tooltip: "Desativar usuário",
              onClick: (event, data) => {
                setModal("desativar");
                setUsuario(data);
              },
            }),
            (rowData) => ({
              hidden: rowData.situacao === "A" ? true : false,
              icon: () => <EjectIcon />,
              tooltip: "Ativar usuário",
              onClick: (event, data) => {
                setModal("ativar");
                setUsuario(data);
              },
            }),
          ]}
        />
      </PerfectScrollbar>
      <Paginate
        rowsPerPageOptions={[10, 25, 50]}
        rowsPerPage={usuarios_perpage}
        count={usuarios_total}
        page={usuarios_page - 1}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Container>
  );
}

export default Usuarios;
